/* eslint-disable no-console */
import React from "react";

import { RemoveButton } from "../../../../components/Buttons/RemoveButton";

export const ArrayRemoveButton = ({
  arrayHelpers,
  dataArray,
  itemIndex,
  prospectPath,
  updateProspect,
  ...props
}) => (
  <RemoveButton
    onClick={() => {
      if (itemIndex > -1) {
        arrayHelpers.remove(itemIndex);
        const removedArray = [...dataArray];
        removedArray.splice(itemIndex, 1);
        updateProspect({
          [prospectPath]: removedArray
        });
      }
    }}
    {...props}
  />
);
